<template>
  <transition name="overlay-fade">
    <div class="login page">
      <div class="main">
        <div class="header">Login</div>
        <div class="content">
          <md-input-container>
            <label>E-mail</label>
            <md-input
              type="text"
              v-model="email"
              required>
            </md-input>
          </md-input-container>

          <md-input-container md-has-password>
            <label>Password</label>
            <md-input
              type="password"
              v-model="password"
              @keyup.enter.native="makeLogin"
              required>
            </md-input>
          </md-input-container>
        </div>
        <div class="buttons">
          <md-button class="md-raised" @click="makeLogin">login</md-button>
        </div>

        <div class="error" v-if="error">
          {{ error }}
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import * as authService from '../services/auth.service'
  import * as userService from '../services/user.service'

  export default {
    name: 'Login',
    data () {
      return {
        email: '',
        password: '',
        error: ''
      }
    },

    methods: {
      makeLogin () {
        authService.makeLogin({
          email: this.email,
          password: this.password
        })
          .then(response => {
            this.error = ''
          })
          .then(() => {
            userService.getCurrent()
              .then(user => this.$store.commit('SET_USER', user.data))
              .then(() => this.$router.push('profile'))
              .catch(error => console.log(error))
          })
          .catch((error) => {
            console.log('error', error)
            this.error = error.status === 404 ? 'User with same email not found' : error.message
          })
      }
    }
  }
</script>

<style lang="scss">
  .login.page {
    padding: 50px;
    width: 100%;
    height: 70%;
    display: flex;
    justify-content: center;
    align-items: center;

    input[type=password], input[type=text] {
      text-shadow: 0 0 0 $color-font-main !important;
      color: $color-font-main !important;
    }

    .main {
      padding: 30px 15px;
      background: $color-gray-middle;
      width: 400px;
      border: 2px solid $color-line-dark;
      border-radius: 2px;
      box-shadow: 0 11px 15px -7px rgba(0, 0, 0, .2),
      0 24px 38px 3px rgba(0, 0, 0, .14),
      0 9px 46px 8px rgba(0, 0, 0, .12);

      label {
        color: #fff;
      }

      .header {
        text-align: center;
      }

      .buttons {
        display: flex;
        justify-content: flex-end;
        .md-theme-default.md-button:not([disabled]).md-raised:not(.md-icon-button) {
          background-color: $color-body;
          color: #fff;
        }
      }

      .error {
        background-color: $color-error;
        padding: 10px;
        font-size: 12px;
        opacity: 1;
        transition: all 0.5s;
      }
    }
  }

  .overlay-fade-enter-active, .overlay-fade-leave-active {
    transition: all .2s;
  }

  .overlay-fade-enter, .overlay-fade-leave-active {
    opacity: 0;
    padding-top: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Login.vue